export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  
  // If it's already an absolute URL (http, https, data:, or blob:)
  if (
    imagePath.startsWith('http://') || 
    imagePath.startsWith('https://') || 
    imagePath.startsWith('data:') || 
    imagePath.startsWith('blob:')
  ) {
    return imagePath;
  }
  
  // Otherwise, prepend the backend URL
  return `https://avastar-pos-backend.onrender.com${imagePath}`;
};
